export const parseZeroSymbolToNumber = (input: string): number => {
  if (!input || input.length === 0) return 0;

  return parseInt(input.charAt(0) ?? '0', 10);
};
